// EntityList.jsx
import { useState, useEffect } from 'react';
import axios from 'axios';

const EntityList = ({ entityName, fields, apiUrl }) => {
  const [items, setItems] = useState([]);
  const [formData, setFormData] = useState({});
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    const res = await axios.get(apiUrl);
    setItems(res.data);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (editingId) {
      await axios.put(`${apiUrl}/${editingId}`, formData);
    } else {
      await axios.post(apiUrl, formData);
    }
    setFormData({});
    setEditingId(null);
    fetchItems();
  };

  const handleEdit = (item) => {
    setFormData(item);
    setEditingId(item.id);
  };

  const handleDelete = async (id) => {
    await axios.delete(`${apiUrl}/${id}`);
    fetchItems();
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">{entityName} List</h2>
      <div className="mb-4">
        {fields.map((field) => (
          <input
            key={field}
            name={field}
            value={formData[field] || ''}
            onChange={handleChange}
            placeholder={field}
            className="border p-2 m-1"
          />
        ))}
        <button onClick={handleSubmit} className="bg-blue-500 text-white p-2 rounded">
          {editingId ? 'Update' : 'Add'}
        </button>
      </div>

      <table className="min-w-full border">
        <thead>
          <tr>
            {fields.map((field) => (
              <th key={field} className="border p-2">{field}</th>
            ))}
            <th className="border p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id}>
              {fields.map((field) => (
                <td key={field} className="border p-2">{item[field]}</td>
              ))}
              <td className="border p-2">
                <button onClick={() => handleEdit(item)} className="mr-2 text-blue-500">Edit</button>
                <button onClick={() => handleDelete(item.id)} className="text-red-500">Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EntityList;
